import PhilippinesAmountForm from "./forms/PhilippinesAmountForm";
import PhilippinesPaymentDetailsForm from "./forms/PhilippinesPaymentDetailsForm";
import PhilippinesBeneficiaryForm from "./forms/PhilippinesBeneficiaryForm";
import PhilippinesWalletBeneficiaryForm from "./forms/PhilippinesWalletBeneficiaryForm";
import PhilippinesReviewForm from "./forms/PhilippinesReviewForm";
import { FormRegistryMap } from "../../shared/types";

export const philippinesFormRegistry: FormRegistryMap = {
  amount: {
    bank: PhilippinesAmountForm,
    default: PhilippinesAmountForm,
  },
  payment: {
    bank: PhilippinesPaymentDetailsForm,
    default: PhilippinesPaymentDetailsForm,
  },
  beneficiary: {
    bank: PhilippinesBeneficiaryForm,
    wallet: PhilippinesWalletBeneficiaryForm,
    default: PhilippinesBeneficiaryForm,
  },
  review: {
    bank: PhilippinesReviewForm,
    default: PhilippinesReviewForm,
  },
};
